// extracted by mini-css-extract-plugin
export var displayNone = "_nx-6";
export var imgContainer = "_nx-2";
export var overflowHidden = "_nx-3";
export var productInfoCardButtonContainer = "_nx-5";
export var productTitleText = "_nx-4";
export var rightArrow = "_nx-1";
export var rightArrowContainer = "_nx-0";